export default __webpack_public_path__ + "static/media/rafael-sanchez-decorate-review.130f371f.jpg";